import { render, staticRenderFns } from "./video-detail.vue?vue&type=template&id=6e1c8028&"
import script from "./video-detail.vue?vue&type=script&lang=js&"
export * from "./video-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports